import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import React, { Component } from 'react';

import InsuredForm from './InsuredForm';
import {
  addInsuredForm,
  removeInsuredForm,
  changeInsuredFormAttr,
  finishPurchase,
  validatorHandlerBlur,
} from '../../../actions/purchaseActions';
import ButtonStage from '../../standard/button_stage/ButtonStage';
import { formatPrice } from '../../../utils';
import dataLayer from '../../../utils/dataLayer';

import './InsuredRegister.css';
import matomoTracker from '../../../utils/matomo';

class InsuredRegister extends Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleChangeAddSegurados = this.handleChangeAddSegurados.bind(this);
  }

  handleChange(e, formId) {
    const field = { name: e.target.name, value: e.target.value, formId };
    this.props.changeInsuredFormAttr(field);
  }

  handleChangeAddSegurados() {
    dataLayer.genericEvent('sg_event', 'sp_pagamento', 'click_botao', 'Adicionar segurados');

    matomoTracker.trackEvent('Checkout', 'AddInsured', 'Click')
    this.props.addInsuredForm();
  }

  render() {
    if (!this.props.plan[0]) return <div />;

    const plan = this.props.plan[0];

    return (
      <div
        className="card-segurados"
        style={{ display: this.props.stagePurchase !== 1 && this.props.mobile ? 'none' : 'flex' }}
      >
        <div className="box-item">
          <div className="card-segurados-header">
            <span className="desktop">Identificação dos Segurados</span>
            <span className="mobile">Informe os dados dos segurados</span>
          </div>

          <div className="body-box-item">
            <div className={`segurados${this.props.match.params.destination === 'receptivo' ? ' incoming-form' : ''}`}>
              {this.props.insuredForms.map((form, i) => (
                <InsuredForm
                  {...form}
                  key={i}
                  index={i}
                  errors={this.props.errors}
                  handleChange={this.handleChange}
                  userDetails={this.props.userDetails}
                  canDelete={this.props.isInsuredFormDeletable}
                  removeInsuredForm={this.props.removeInsuredForm}
                  validatorHandlerBlur={this.props.validatorHandlerBlur}
                  destination={this.props.match.params.destination}
                />
              ))}

              <button
                type="button"
                name="btn-add-segurados"
                id="btn-add-segurados"
                className="add-segurados"
                onClick={() => this.handleChangeAddSegurados()}
              >
                <img alt="add" src="/assets/images/icons/add.svg" />
                Adicionar segurados
              </button>

              <div>
                <ButtonStage data-cy="insured-step" index={2} stage="INSURED_CONTACT" />
                {plan.elder.min_age < plan.elder.max_age && (
                  <p className="info-elder-mobile">
                    Para maiores de {plan.adult.max_age} anos, o valor do seguro viagem é
                    <b>R$ {formatPrice(plan.elder.price)}</b> por pessoa.
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(
  connect(
    (state) => ({
      insuredForms: state.purchase.insuredForms,
      isInsuredFormDeletable: state.purchase.isInsuredFormDeletable,
      errors: state.purchase.errors,
      userDetails: state.purchase.userDetails,
      mobile: state.mobile.mobileActive,
      stagePurchase: state.purchase.stagePurchase,
      purchaseSummary: state.purchase.purchaseSummary,
      plan: state.search.plans,
    }),
    {
      addInsuredForm,
      removeInsuredForm,
      changeInsuredFormAttr,
      finishPurchase,
      validatorHandlerBlur,
    }
  )(InsuredRegister)
);



// WEBPACK FOOTER //
// ./src/components/purchase/insured_register/InsuredRegister.jsx